import "./Header.css";
import axios from "axios";
import React, { useState } from "react";
import { Button, Col, Row, Form, Spinner } from "react-bootstrap";
import { toast } from "sonner";
import { isValidUSPhone } from "../../utils/phoneValidation";
import { validateOhioAddress } from "../../utils/addressValidation";

function InstantRoofQuote({ source, handleClose }) {
    const getApiUrl = (path) => {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const base = isLocal ? 'http://localhost:8081' : 'https://ultimatesroofing.com/api';
        return `${base}${path}`;
    };

    const url = getApiUrl("/ultimates/customer/register");

    const [errorMessage, setErrorMessage] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState({
        name: "",
        phoneNumber: "",
        email: "",
        address: "",
        service: "",
        source: "modal",
        message: "",
    });

    // Event handler for input changes
    const handleInputChange1 = (e) => {
        const { name, value } = e.target;
        setErrorMessage("");
        setAddressError(false);

        setDetails((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // Event handler for form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        setErrorMessage("");
        setAddressError(false);

        if (
            details.name === "" ||
            details.phoneNumber === "" ||
            details.email === "" ||
            details.address === "" ||
            details.service === "" ||
            details.message === ""
        ) {
            setErrorMessage("Please fill all required fields");
            toast.error("Please fill all required fields");
        } else if (!isValidUSPhone(details.phoneNumber)) {
            setErrorMessage("Please enter a valid US phone number");
            toast.error("Please enter a valid US phone number");
        } else {
            setErrorMessage("");
            setLoading(true);

            const addrResult = await validateOhioAddress(details.address);
            if (!addrResult.valid) {
                setAddressError(true);
                setErrorMessage(addrResult.error);
                toast.error(addrResult.error);
                setLoading(false);
                return;
            }

            // Split full name into first name and last name for backend API
            const nameParts = details.name.trim().split(' ');
            const firstName = nameParts[0] || '';
            const lastName = nameParts.slice(1).join(' ') || '';

            const { name, ...otherDetails } = details;
            SubmitData({
                ...otherDetails,
                firstName,
                lastName,
            });
        }
    };

    // Function to submit form data to the server
    const SubmitData = (ModalData) => {
        const formData = new FormData();
        formData.append("customerJson", JSON.stringify(ModalData));
        axios
            .post(url, formData)
            .then((res) => {
                // Reset the form after successful submission
                setDetails({
                    name: "",
                    phoneNumber: "",
                    email: "",
                    address: "",
                    service: "",
                    source: "modal",
                    message: "",
                });

                if (source === "request") {
                    toast.success("We will call you back shortly.");
                } else {
                    toast.success("We will get back to you as soon as possible.");
                }
                // Close the modal after successful submission
                handleClose();
            })
            .catch((error) => {
                if (error.response) {
                    const errMsg = error.response.data.message || "Submission failed";
                    setErrorMessage(errMsg);
                    toast.error(errMsg);
                } else {
                    setErrorMessage(
                        "An unexpected error occurred. Please try again."
                    );
                    toast.error("An unexpected error occurred. Please try again.");
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div>
            {/* Form Component */}
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Form className="model-form">
                    <Row className="names-roww">
                        <Col>
                            <Form.Group>
                                <Form.Label className="label d-flex justify-content-start">
                                    Name{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={details.name}
                                    onChange={handleInputChange1}
                                    isInvalid={formSubmitted && details.name.trim() === ""}
                                    placeholder="Type Your Full Name"
                                    className="input"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="names-roww">
                        <Col>
                            <Form.Group>
                                <Form.Label className="label d-flex justify-content-start">
                                    Phone Number{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="phoneNumber"
                                    value={details.phoneNumber}
                                    onChange={handleInputChange1}
                                    isInvalid={(formSubmitted && details.phoneNumber.trim() === "") || errorMessage === "Please enter a valid US phone number"}
                                    className="input"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="names-roww">
                        <Col>
                            <Form.Group>
                                <Form.Label className="label d-flex justify-content-start">
                                    Email{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={details.email}
                                    onChange={handleInputChange1}
                                    isInvalid={formSubmitted && details.email.trim() === ""}
                                    className="input"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="names-roww">
                        <Col>
                            <Form.Group>
                                <Form.Label className="label d-flex justify-content-start">
                                    Service <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Select
                                    name="service"
                                    value={details.service}
                                    onChange={handleInputChange1}
                                    isInvalid={formSubmitted && details.service === ""}
                                    className="input"
                                >
                                    <option value="" disabled>Select Service</option>
                                    <option>Residential Roofing</option>
                                    <option>Commercial Roofing</option>
                                    <option>Siding Service</option>
                                    <option>Gutters System</option>
                                    <option>Window Service</option>
                                    <option>Painting Service</option>
                                    <option>Flooring Service</option>
                                    <option>Power Wash</option>
                                    <option>Renovation Service</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="names-roww">
                        <Col>
                            <Form.Group>
                                <Form.Label className="label d-flex justify-content-start">
                                    Property Address <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address"
                                    value={details.address}
                                    onChange={handleInputChange1}
                                    isInvalid={(formSubmitted && details.address.trim() === "") || addressError}
                                    className="input"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                        <Row className="names-roww">
                            <Form.Group>
                                <Form.Label className="label d-flex justify-content-start">
                                    Message <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="message"
                                    value={details.message}
                                    onChange={handleInputChange1}
                                    isInvalid={formSubmitted && details.message.trim() === ""}
                                    placeholder="Please enter your message"
                                    className="input"
                                    style={{ height: "8vh" }}
                                />
                            </Form.Group>
                        </Row>
                    <div className="errormessage">
                        {errorMessage !== "" ? (
                            <div>
                                <p style={{ margin: "0px" }}>{errorMessage}</p>
                            </div>
                        ) : null}
                    </div>
                    {/* Submit Button */}
                    <div style={{ textAlign: "center" }}>
                        <Button
                            onClick={handleSubmit}
                            type="submit"
                            style={{ marginTop: "2rem", padding: "1rem 5rem" }}
                            className="form-btn"
                        >
                            Submit
                        </Button>
                    </div>
                </Form>
            </div>

            {/* Loading Spinner */}
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-indicator">
                        <Spinner animation="border" variant="primary" />
                    </div>
                </div>
            ) : null}
        </div>
    );
}
export default InstantRoofQuote;
